import React, { Fragment, FunctionComponent } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { Icon, IconType } from '../Icon'
import classNames from 'classnames'

interface IProps {
  value: number
  onChange: (newValue: number) => void
  options?: number[]
  disabled?: boolean
  className?: string
}

const PageSizeSelector: FunctionComponent<IProps> = ({
  value,
  onChange,
  options = [5, 10, 25, 50],
  disabled = false,
  className = '',
}) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <label className='text-sm text-gray-600'>Show:</label>
      <Menu as='div' className='relative'>
        <Menu.Button
          disabled={disabled}
          className={classNames(
            'flex items-center text-xs py-1 px-2 border border-gray-300 rounded-md bg-white shadow-sm focus:border-gray-800 focus:outline-none focus:ring-1 focus:ring-gray-800',
            disabled
              ? 'opacity-50 cursor-not-allowed'
              : 'cursor-pointer hover:border-gray-400',
          )}
        >
          <span className='mr-1'>{value} per page</span>
          <Icon
            type={IconType.chevronDown}
            className='w-3 h-3 text-gray-400'
            aria-hidden='true'
          />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter='transition ease-out duration-100'
          enterFrom='transform opacity-0 scale-95'
          enterTo='transform opacity-100 scale-100'
          leave='transition ease-in duration-75'
          leaveFrom='transform opacity-100 scale-100'
          leaveTo='transform opacity-0 scale-95'
        >
          <Menu.Items className='absolute right-0 z-10 mt-1 w-28 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
            <div className='py-1'>
              {options.map((option) => (
                <Menu.Item key={option}>
                  {({ active }) => (
                    <button
                      onClick={() => onChange(option)}
                      className={classNames(
                        active ? 'bg-gray-50' : '',
                        option === value
                          ? 'bg-gray-100 text-gray-900 font-medium'
                          : 'text-gray-700',
                        'block w-full text-left px-3 py-1 text-xs hover:bg-gray-50',
                      )}
                    >
                      {option} per page
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}

export { PageSizeSelector }
